import React from "react";
import { displayIcon } from "variables/icons";
import HyvidChat from "./index";
import { MODULE_HYVID_CHAT } from "variables/modules";

const hyvidChatRoutes = [
	{
    	name: "Hyvid Chat",
	    layout: "/console",
	    path: "hyvid-chat",
	    icon: displayIcon('MessageCircle', 'icon-item'),
	    component: <HyvidChat />,
	    isMainMenu:true,
		level:5,
		moduleId: MODULE_HYVID_CHAT,
  	},
]

export default hyvidChatRoutes;